import React from 'react';
import styled from 'styled-components';
import AllRoomsSection from '../HousingSection/all-rooms';
import HowBadiWorks from '../HowBadiWorks';
import WhyBadiWorks from '../WhyBadiWorks';
import FAQSection from '../FAQ';
import AppDownloadBanner from '../AppDownloadBanner';

const Container = styled.div`
  width: 100%;
  margin: 0 auto;
  padding: 4rem 3rem;

  @media (max-width: 768px) {
    padding: 2rem 1rem;
  }
`;

const AllRooms = ({ location }) => {
  return (
    <Container>
      <AllRoomsSection location={location} />
      <HowBadiWorks />
      <AppDownloadBanner />
      <WhyBadiWorks />
      <FAQSection />
    </Container>
  );
};

export default AllRooms;
